import i18n from '@risksmart-app/i18n/src/i18n';
import { type FC } from 'react';

import ValueWidget from '../value-widget/ValueWidget';

type Props = {
  unit?: string;
  loading?: boolean;
  value?: number;
  onClick?: () => void;
  noClickthroughMessageContent?: string;
  /**
   * Formats the value for display (e.g. cost columns render as 2-decimal
   * locale strings, RSP-5735). When absent, falls back to the default 1-dp
   * rounding used for counts and other plain numeric widgets.
   */
  formatValue?: (value: number) => string;
};

const NumberWidget: FC<Props> = ({ value, unit, formatValue, ...rest }) => {
  return (
    <ValueWidget
      value={
        value !== undefined
          ? (formatValue?.(value) ?? String(Math.round(value * 10) / 10))
          : undefined
      }
      unit={unit ?? i18n.t('dashboard.units.total')}
      {...rest}
    />
  );
};

export default NumberWidget;
